import { WrapperEntitySelector } from '@components/Inputs';
import { TextInput } from '@ts/storybook';
import { generateSearchEntitySelector } from '@modules/entitySelector/entitySelector.utils';
import { IForm } from '@ts/ui-models';

const FormContactData = (props: IForm) => {
  const { values, mode, onCallbackChange, requiredFields } = props;
  const isViewMode = mode === 'view';

  //#region Handlers
  const handleChangeEntitySelector = (entity, entityName, fkField) => {
    const value = entity ? entity.getID() : null;
    props.onChange(entityName, entity);
    props.onChange(fkField, value);
  };
  //#endregion

  return (
    <>
      <TextInput
        isReadOnly={isViewMode}
        label="Name"
        value={values.name}
        onChangeValue={onCallbackChange('name')}
        required={requiredFields.includes('name')}
        infoText="Blank spaces at the beggining and the end will be trimmed on save"
      />
      <WrapperEntitySelector
        searchComponent={generateSearchEntitySelector('contactDataType')}
        isReadOnly={mode !== 'new'}
        label={'Contact data type'}
        value={props.values.ContactDataType}
        onChangeEntity={entity => handleChangeEntitySelector(entity, 'ContactDataType', 'contactDataTypeLogicalId')}
        required={requiredFields.includes('contactDataTypeLogicalId')}
      />
      <TextInput isReadOnly={isViewMode} label="Value" value={values.data} onChangeValue={onCallbackChange('data')} />
    </>
  );
};

export default FormContactData;
